"use client";

import React, { useEffect, useState } from "react";
import { usePathname, useRouter } from "next/navigation";
import AdminSidebar from "@/components/admin/AdminSidebar";
import AdminHeader from "@/components/admin/AdminHeader";
import { GlobalDrawerManager } from "@/components/admin/GlobalDrawerManager";

export default function AdminLayoutWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const router = useRouter();
  const [isMounted, setIsMounted] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);

  const isAdminRoute = pathname?.startsWith("/admin");
  const isLoginRoute = pathname === "/admin/login/";

  useEffect(() => {
    setIsMounted(true);

    if (isAdminRoute) {
      const userGuid = localStorage.getItem("UserGUID");
      const normalizedPathname = pathname?.endsWith("/") ? pathname : `${pathname}/`;
      const loginPath = "/admin/login/";

      if (!userGuid && normalizedPathname !== loginPath) {
        router.replace(loginPath);
      } else if (userGuid && normalizedPathname === loginPath) {
        router.replace("/admin/");
      } else {
        setIsAuthorized(true);
      }
    }
 else {
      setIsAuthorized(true);
    }
  }, [pathname, isAdminRoute, isLoginRoute, router]);

  // Initial mount guard
  if (!isMounted) {
    return (
      <div className="flex items-center justify-center min-h-screen w-full bg-slate-50">
        <div className="w-8 h-8 border-4 border-gold-dim border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  // If we are on an admin route, we must wait for authorization
  if (isAdminRoute && !isAuthorized) {
    return (
      <div className="flex items-center justify-center min-h-screen w-full bg-slate-50">
        <div className="w-8 h-8 border-4 border-gold-dim border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  const isPrintRoute =
    pathname?.includes("/admin/orders/view") ||
    pathname?.includes("/admin/orders/label") ||
    pathname?.includes("/admin/report/order/print");

  // Public site, Login page, or Print views (no sidebar)
  if (!isAdminRoute || isLoginRoute || isPrintRoute) {
    return <>{children}</>;
  }

  // Actual Admin Panel with full persistent shell
  return (
    <div className="flex h-[100dvh] print:h-auto print:block overflow-hidden print:overflow-visible bg-slate-50 print:bg-white text-slate-800">
      <AdminSidebar />
      <div className="flex flex-col flex-1 print:flex-none print:block overflow-hidden print:overflow-visible">
        <AdminHeader />
        <main className="flex-1 print:flex-none print:block overflow-y-auto print:overflow-visible p-4 md:p-6 print:p-0 print:m-0 bg-slate-50 print:bg-white">
          {children}
        </main>
      </div>
      <GlobalDrawerManager />
    </div>
  );
}
